import $ from 'jquery'

function init () {
  $('.back-to-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  })
}

export default {
  init
}
